<template>
  <div class="vx-row">
    <!-- HORIZONTAL LAYOUT -->
    <div class="vx-col w-full mb-base" id="button-with-loading">
      <form @submit.prevent="onSubmit">
        <vx-card name="Create PartnerContent">
          <div>
            <vs-alert
              active="true"
              color="danger"
              v-if="submit_errors.length > 0"
            >
              <p>List error :</p>
              <vs-list>
                <vs-list-item
                  :title="error.message"
                  v-for="error in submit_errors"
                  :key="error.index"
                ></vs-list-item>
              </vs-list>
            </vs-alert>
          </div>
          <br />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Store</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-model="store"
                  label="name"
                  item-value="id"
                  :options="stores"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Title</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >{{ countChar(title) }}/250</span
              >
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="title"
                name="Title"
              />
              <span class="text-danger text-sm" v-show="errors.has('Title')">{{
                errors.first("Title")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-model="type"
                  label="name"
                  item-value="value"
                  :options="types"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>
                Content
                <small>*Max. 1000 Character</small>
              </span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >{{ countChar(content) }}/1000</span
              >
              <quill-editor
                v-model="content"
                v-validate="'required|max:1000'"
                name="Content"
                :options="editorDesc"
              >
                <div id="desc" slot="toolbar">
                  <quill-custom />
                </div>
              </quill-editor>

              <span
                class="text-danger text-sm"
                v-show="errors.has('Content')"
                >{{ errors.first("Content") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Video Url</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >{{ countChar(video_url) }}/250</span
              >
              <vs-input
                v-validate="'max:250'"
                class="w-full"
                v-model="video_url"
                name="Video Url"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Video Url')"
                >{{ errors.first("Video Url") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Action Button Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-model="action_button_type"
                  label="name"
                  item-value="value"
                  :options="button_types"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Action Button Text</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >{{ countChar(action_button_text) }}/250</span
              >
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="action_button_text"
                name="Action Button Text"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Action Button Text')"
                >{{ errors.first("Action Button Text") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Action Button Content</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <span class="text-normal text-sm"
                >{{ countChar(action_button_content) }}/250</span
              >
              <vs-input
                v-validate="'required|max:250'"
                class="w-full"
                v-model="action_button_content"
                name="Action Button Content"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Action Button Content')"
                >{{ errors.first("Action Button Content") }}</span
              >
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Action Button Hidden</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-model="is_action_button_hidden"
                  label="name"
                  item-value="value"
                  :options="bool_status"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Active</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <template>
                <v-select
                  v-model="is_active"
                  label="name"
                  item-value="value"
                  :options="bool_status"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                />
              </template>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Sequence</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                v-validate="''"
                class="w-full"
                v-model="sequence"
                name="Sequence"
                type="number"
              />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Photo</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                class="w-full"
                type="file"
                id="photo"
                name="Photo"
                accept="image/x-png, image/jpeg, image/jpg"
                @change="onFileSelectedPhoto"
              />
              <br />
              <img :src="current_photo" class="rounded" width="200" />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Icon</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input
                class="w-full"
                type="file"
                id="icon"
                name="Icon"
                accept="image/x-png, image/jpeg, image/jpg"
                @change="onFileSelectedIcon"
              />
              <br />
              <img :src="current_icon" class="rounded" width="200" />
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button class="mr-3 mb-2" button="submit">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>

<script>
import QuillCustom from '../template/QuillCustom'
import PreviewJob from '../template/PreviewJob'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import axios from '../../../axios110'
import router from '../../../router'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  data() {
    return {
      userAuth: this.$store.state.user,

      title: '',

      store: { id: "", name: "" },
      stores: [],
      types: [{ name: 'General', value: 'general' }, { name: 'Redirect', value: 'redirect' }, { name: 'Redirect In App', value: 'redirect_in_app' }, { name: 'Herobanner', value: 'herobanner' }, { name: 'Banner', value: 'banner' }, { name: 'Custom', value: 'custom' }, { name: 'Store Page', value: 'store_page' }],
      type: {},
      button_types: [{ name: 'Wa', value: 'wa' }, { name: 'Redirect', value: 'redirect' }, { name: 'Call', value: 'call' }],
      content: "",
      photo: '',
      icon: '',
      current_photo: "",
      current_icon: "",
      video_url: '',
      action_button_content: '',
      action_button_text: '',
      action_button_type: '',
      bool_status: [{ name: 'Yes', value: 1 }, { name: 'No', value: 0 }],
      is_action_button_hidden: { name: 'No', value: 0 },
      is_active: { name: 'Yes', value: 1 },
      sequence: '',
      colorAlert: 'primary',
      nameAlert: 'Alert',
      activeAlert: false,
      valueInput: '',


      editorDesc: {
        modules: {
          toolbar: '#desc'
        }
      },
      editorReq: {
        modules: {
          toolbar: '#req'
        }
      },
      editorBenefit: {
        modules: {
          toolbar: '#content'
        }
      },
      content: '',
      colorx: "white",
      popupActive: false,
      submit_errors: []
    }
  },
  components: {
    quillEditor,
    'v-select': vSelect,
    Datepicker,
    QuillCustom,
    PreviewJob
  },
  mounted() {
    this.getStore()
    this.getContent()
  },

  methods: {
    getStore() {
      //console.log('ini mounted')
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45
      })
      //axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.getters.tokenAuth
      axios.get('/ecommerce/web/store' + '?limit=100', {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            console.log(res)
            this.stores = res.data
          }
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")

        })
        .catch(error => {
          console.log(error.response)
          this.$vs.loading.close("#button-with-loading > .con-vs-loading")
        })

    },
    getContent() {
      axios.get('/ecommerce/web/partner_content/' + this.$route.params.partnercontentId, {})
        .then(res => {
          if (res.status != 200) {
            console.log(res.status)
            //   this.errorRecover = true
            //   this.messageRecover = 'Email tidak terdaftar!'
          } else {
            var partner_content = res.data
            this.title = partner_content.title
            this.store = partner_content.store
            this.content = partner_content.content
            this.video_url = partner_content.video_url === null ? '' : partner_content.video_url
            this.action_button_text = partner_content.action_button_text
            this.action_button_content = partner_content.action_button_content
            this.is_action_button_hidden = this.bool_status.find(o => o.value === (partner_content.is_action_button_hidden ? 1 : 0))
            this.is_active = this.bool_status.find(o => o.value === (partner_content.is_active ? 1 : 0))
            this.type = this.types.find(o => o.value === partner_content.type)
            this.action_button_type = this.button_types.find(o => o.value === partner_content.action_button_type)
            this.current_photo = partner_content.photo
            this.current_icon = partner_content.icon
            this.sequence = partner_content.sequence

          }


        })
        .catch(error => {
          console.log(error.response)

        })

    },
    countChar(str) {
      if (str) {
        return str.length
      }
      else {
        return 0
      }

    },
    limitChar(str) {
      var output = ''
      if (str.length > 100) {
        str = str.substring(0, 100)
        output = str + '...'
      } else {
        output = str
      }
      return output
    },
    format_date(value) {
      // if (value) {
      //   return moment(String(value)).format('YYYY-MM-DD')
      // }

      const d = value
      const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d)
      const mo = new Intl.DateTimeFormat('en', { month: 'short' }).format(d)
      const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d)
      return `${da} ${mo} ${ye}`
    },
    onSubmit() {
      this.submit_errors = []
      var formData = new FormData();
      formData.append('id', this.$route.params.partnercontentId)
      if (this.photo) {
        formData.append('photo', this.photo, this.photo.name)
      }
      if (this.icon) {
        formData.append('icon', this.icon, this.icon.name)
      }
      if (this.store) {
        formData.append('store_id', this.store.id)
      }

      formData.append('title', this.title)
      formData.append('type', this.type.value)
      formData.append('content', this.content)
      formData.append('video_url', this.video_url)
      formData.append('action_button_type', this.action_button_type ? this.action_button_type.value : null)
      formData.append('action_button_text', this.action_button_text)
      formData.append('action_button_content', this.action_button_content)
      formData.append('is_action_button_hidden', this.is_action_button_hidden ? this.is_action_button_hidden.value : 0)
      formData.append('is_active', this.is_active ? this.is_active.value : 1)
      formData.append('sequence', this.sequence)


      // for (var value of formData.values()) {
      //   console.log(value);
      // }
      // return
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          axios.post('ecommerce/web/partner_content/update', formData)
            .then(res => {
              this.acceptAlert('success', 'Success', 'Partner Content Updated')
              this.$vs.loading.close()
              router.push('/PartnerContent')

            })
            .catch(error => {
              console.log(error.response)
              this.$vs.loading.close()
              this.submit_errors = error.response.data.errors
              window.scrollTo(0, 0);

            })
        } else {
          this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')

        }
      })


    },
    onMultipleFileSelected(event) {


      for (var i = 0; i < event.target.files.length; i++) {
        this.photos[i] = event.target.files[i];

      }
    },

    acceptAlert(color, name, message) {

      this.$vs.notify({
        color,
        name,
        text: message
      })

    },
    onFileSelectedPhoto(event) {
      this.photo = event.target.files[0]
    },
    onFileSelectedIcon(event) {
      this.icon = event.target.files[0]
    },
  },

}
</script>

